// Used in EditableHours.tsx
//
// I just did basic string manipulation here. Since both the
// input and output currently shouldn't care about timezones
// and offsets, this is the cleanest and simplest way to set
// hours and minutes on a manipulable ISO date string.
//
// Since our use case also currently doesn't care about the
// year, month and day, I have it defaulted to the start of
// 2020. You can still pass in a secondary optional param for
// testing etc.
export const militaryTimeToISO = (
  militaryTime?: number,
  baseDTString: string = "2020-01-01T00:00:00.000+00:00",
): string => {
  const standardizeTime = String(militaryTime).padStart(4, "0");
  const hours = standardizeTime.substring(0, 2);
  const minutes = standardizeTime.substring(2, 4);

  const updatedDTString = `${baseDTString.substring(
    0,
    11,
  )}${hours}:${minutes}${baseDTString.substring(16)}`;

  return updatedDTString;
};

export const isoToMilitaryTime = (isoString?: string): number => {
  if (!isoString) {
    return 0;
  }
  const extractedHHMM = isoString.substring(11, 13) + isoString.substring(14, 16);
  return parseInt(extractedHHMM);
};

// These two utils are for cases where militaryTime is at the final or first
// second. For example - 8:59 plus one minute is 9:00. However, 859 + 1 would
// be 860, which is an invalid value. Same with 8:00 minus 1 minute - 7:99 is
// invalid. Ion-Datetime throws an error when you pass in an invalid time
// string, hence these utils.

export const subtractOneMinute = (militaryTime: number) => {
  if (militaryTime % 100 === 0) {
    return militaryTime - 41;
  }
  return militaryTime - 1;
};

export const addOneMinute = (militaryTime: number) => {
  if (militaryTime.toString().slice(-2) === "59") {
    return militaryTime + 41;
  }
  return militaryTime + 1;
};
